import type { PropsWithChildren } from "react";

import { useLookupPlace } from "@/hooks/useLocationSearch";

export function GoogleMapsLink({
  placeId,
  className,
  children,
}: PropsWithChildren<{
  placeId: string;
  className?: string;
}>) {
  const place = useLookupPlace(placeId);
  if (!place.data?.googleMapsURI) return null;

  return (
    <a href={place.data.googleMapsURI} target="_blank" rel="noopener noreferrer" className={className}>
      {children ?? place.data.googleMapsURI}
    </a>
  );
}
